import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.PRODUCTS_AND_SERVICES}.${BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.ADVANTAGES}` as const;

export const PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES = {
  PRODUCT_VALUE: 'productValue',
} as const;

export interface IProductAndServicesAdvantagesForm {
  [PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE]: string;
}

export const productAndServicesAdvantagesInitialValues: IProductAndServicesAdvantagesForm = {
  [PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE]: '',
};
